import { defaultPageMetaConfig, PageMetaConfig } from '@spartacus/core';

export const pageMetaConfig: PageMetaConfig = {
  pageMeta: {
    ...defaultPageMetaConfig.pageMeta,
    resolvers: [
      ...defaultPageMetaConfig.pageMeta.resolvers,
      {
        property: 'categoryBreadcrumbs',
        method: 'resolveCategoryBreadcrumbs',
      },
      {
        property: 'subTitle',
        method: 'resolveSubTitle',
      },
      {
        property: 'seoText',
        method: 'resolveSeoText',
      },
      {
        property: 'description',
        method: 'resolveDescription',
        disabledInCsr: false,
      },
      {
        property: 'canonicalUrl',
        method: 'resolveCanonicalUrl',
        disabledInCsr: false,
      },
      {
        property: 'loading',
        method: 'resolveLoading',
      },
      {
        property: 'type',
        method: 'resolveType',
        disabledInCsr: false,
      },
      {
        property: 'ogTitle',
        method: 'resolveOgTitle',
      },
      {
        property: 'ogDescription',
        method: 'resolveOgDescription',
      },
    ],
    canonicalUrl: {
      ...defaultPageMetaConfig.pageMeta.canonicalUrl,
      forceTrailingSlash: false,
    },
  },
};
